/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { goToRouteBySearch } from '@/components/common/EnquiriesScreen/utils/goToRouteBySearch';
import { useGetredirectLink } from '@/components/common/EnquiriesScreen/utils/useGetRedirectLink';
import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { getHeaderColumns } from '../columns/headerColumns';
import { contractsBCPath } from '@/utils/path.utlis';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToUpliftsBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {
  const getRedirectLink = useGetredirectLink();

  const getContractLink = (contractId: string, searchString?: string) => {
    let link = getRedirectLink(window.location.pathname, contractId, searchString);
    if (!link.includes('/contracts')) {
      link = link.replace('/uplifts-history/', `/uplifts-history/${contractsBCPath}/`);
    }
    return getParameterizedLink(link);
  };

  const goToContract = (contractLink: string) => {
    browserHistory.push(getParameterizedLink(contractLink));
  };

  const goToUpliftsBySearch = (searchText?: string) => {
    goToRouteBySearch(searchText);
  };

  return useMemo(() => {
    const headerColumns = getHeaderColumns({ getContractLink, goToContract });
    return {
      headerColumns,
      goToUpliftsBySearch,
    };
  }, []);
};
